module.exports = __webpack_public_path__ + "static/media/title-about-gsteps.421f47b3.png";